import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import useLocale from '../i18n/useLocale';
import Reveal from './Reveal';

const Testimonials = () => {
  const { L } = useLocale();
  const items = L.testimonials.items;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!items.length) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % items.length);
    }, 7000);
    return () => clearInterval(id);
  }, [items.length]);

  if (!items.length) return null;

  const go = (dir) => {
    setIndex((i) => (i + dir + items.length) % items.length);
  };

  const current = items[index];

  return (
    <section id="testimonials" className="section testimonials-section">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-kicker">03 / {L.testimonials.subtitle}</span>
          <h2 className="section-title">
            {L.testimonials.title}<span className="accent">.</span>
          </h2>
        </Reveal>

        <Reveal className="quote-wrap">
          <FaQuoteLeft className="quote-deco" />
          <AnimatePresence exitBeforeEnter>
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -18 }}
              transition={{ duration: 0.45 }}
              className="quote-card glass"
            >
              <p>{current.text}</p>
              <footer>
                <cite>{current.user}</cite>
                <span className="quote-role">{current.role}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>

          <div className="quote-nav">
            <button
              type="button"
              className="quote-arrow clickable"
              onClick={() => go(-1)}
              aria-label="Previous"
            >
              <FaChevronLeft />
            </button>
            <div className="quote-dots">
              {items.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`quote-dot clickable ${i === index ? 'is-active' : ''}`}
                  onClick={() => setIndex(i)}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
            <button
              type="button"
              className="quote-arrow clickable"
              onClick={() => go(1)}
              aria-label="Next"
            >
              <FaChevronRight />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
